import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=74dbc827&scoped=true"
import script from "./SitesTable.vue?vue&type=script&lang=js"
export * from "./SitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dbc827",
  null
  
)

export default component.exports